import CRUD from './CRUD';

/**
 * Provides a set of CRUD operations around Components: /components.
 */
export default class ComponentsClient extends CRUD {
	constructor() {
		super('/components');
	}
}
